
import { Box, ButtonBase, CircularProgress, createTheme, Grid, Stack, ThemeProvider, Typography } from '@mui/material';
import '../Card.css';
import { BarChart, PieChart } from '@mui/x-charts';
import { useNavigate } from 'react-router-dom';
import { controlTowerMenuItems } from '../../../../routes/PrivateRoutes';
import './ShipmentCard.css';
import { useWidgetContext } from '../CTDashboard';
import { useCallback, useState } from 'react';
import { CustomSwitch } from '../../../../Components/Switch/CustomSwitch';

export const ShipmentCardv2 = (props) => {
  const title = props.title
  // const [expandableWidgets.has(title), setOpen] = useState(false)
  const { expandableWidgets, setExpandableWidgets } = useWidgetContext()
  const [isDetailed, setDetailed] = useState(false)
  const updateActiveTab = (tab) => {
    setDetailed(tab);
    setTimeout(() => {
      setExpandableWidgets(title);
    }, 200)
  }
  const theme = createTheme({
    components: {
      MuiTypography: {
        defaultProps: {
          fontSize: 13,
        }
      },
      MuiButtonBase: {
        styleOverrides: {
          root: {
            flexDirection: 'column',
            width: '100%'
          }
        }
      }
    }
  })
  const navigate = useNavigate();

  const totalExceptionCount = props.exceptions?.totalCount || 0
  const totalStatesCount = props.states?.totalCount || 0
  const totalShipmentCount = props.exceptions?.totalShipments || 0


  const totalOnTimeCount = Number(props.exceptions?.data?.find(item => item.label === 'On Time' ||
    item.label === 'On Track')?.value || 0)
  const states = props.states?.data ?? []
  const exceptions = props.exceptions?.data?.filter(item => item.label !== 'On Time' && item.label !== 'On Track') ?? []
  const path = controlTowerMenuItems.find(item => item.label === props.title)?.path
  const valueFormatter = (item, total) => `${total > 0 ? Math.round(item.value * 100 / total) : total}% (${item.value})`
  const menuState = path.includes('supply') ? 'Supply' : path.includes('demand') ? 'Demand' : 'Inventory'
  const label = props.title === 'Inventory' ? 'Inventory List' : (controlTowerMenuItems.find(item => item.label === props.title)?.label)

  const overviewSeries = [
    {
      id: 'Overall',
      innerRadius: 40,
      outerRadius: 65,
      data: exceptions.length === 0 ? [] : [
        {
          id: props.title === 'Inventory' ? 'On Track' : 'On Time',
          label: props.title === 'Inventory' ? 'On Track' : 'On Time',
          value: totalOnTimeCount,
          color: 'forestgreen'
        },
        {
          id: 'Exception',
          label: 'Exceptions',
          value: totalExceptionCount,
          color: 'red'
        },
      ],
      highlightScope: { fade: 'global', highlight: 'item' },
      paddingAngle: 0,
      startAngle: 0,
      endAngle: 360,
      cx: states.length > 0 ? 80 : 130,
      cy: 70,
      valueFormatter: (item) => valueFormatter(item, totalExceptionCount)
    }
  ]
  const exceptionOverview = [
    {
      id: 'Exceptions',
      innerRadius: 40,
      outerRadius: 65,
      data: exceptions.sort((a, b) => a.value - b.value >= 0).slice(0, 3),
      highlightScope: {
        fade: 'global',
        highlight: 'item'
      },
      cornerRadius: 4,
      // paddingAngle: 4,
      // startAngle: -90,
      // endAngle: 90,
      cx: states.length > 0 ? 85 : 130,
      cy: 70,
      // arcLabelMinAngle: 0,
      valueFormatter: (item) => valueFormatter(item, totalExceptionCount - totalOnTimeCount)
    }
  ]

  const statesTotal = states.length > 0 &&
    states.reduce((sum, curr) => sum + curr.value, 0)
  const statesSeries = [{
    id: 'States',
    innerRadius: 40,
    outerRadius: 65,
    data: states.sort((a, b) => a.value - b.value >= 0).slice(0, 3),
    highlightScope: {
      fade: 'global',
      highlight: 'item'
    },
    paddingAngle: 2,
    cx: 85,
    cy: 70,
    arcLabelMinAngle: 0,
    valueFormatter: (item) => valueFormatter(item, statesTotal)
  }]

  const renderCardBody = () =>
    <>
      <Grid id='card-body' size={ { xs: 12 } } sx={ { width: '100%', minHeight: '370px', padding: 1, transition: 'min-height 0.2s' } }>
        <Grid id='chart-container' container>
          {
            !expandableWidgets.has(title) &&
            <Grid id='exceptions-overview' size={ { xs: states.length > 0 ? 4 : 6 } }>
              { renderPieChart('Overview', overviewSeries) }
              <Grid id='exceptions-overview-label' container justifyContent='center' size={ 12 }>
                <Grid size={ 12 }>
                  <Typography sx={ {
                    display: 'inline',
                    fontWeight: 'bold',
                    color: 'forestgreen'
                  } }>
                    { props.title === 'Inventory' ? 'On Track' : 'On Time' } :
                  </Typography>
                  <Typography sx={ {
                    display: 'inline',
                    margin: 0,
                    fontWeight: 'bold',
                    marginLeft: '2px'
                  } }>
                    { totalOnTimeCount } ({ Math.round((totalOnTimeCount / totalExceptionCount) * 100) }%)
                  </Typography>
                </Grid>
                <Grid size={ 12 }>
                  <Typography sx={ {
                    display: 'inline',
                    fontWeight: 'bold',
                    color: 'red'
                  } }>
                    Exceptions:
                  </Typography>
                  <Typography sx={ {
                    display: 'inline',
                    margin: 0,
                    fontWeight: 'bold',
                    marginLeft: '2px'
                  } }>
                    { totalExceptionCount - totalOnTimeCount } ({ Math.round(((totalExceptionCount - totalOnTimeCount) / totalExceptionCount) * 100) }%)
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          }
          {
            !expandableWidgets.has(title) &&
            <>
              <Grid id='exceptions-detailed' size={ { xs: states.length > 0 ? 4 : 6 } }>
                { renderPieChart('Exceptions', exceptionOverview) }
                <Grid id='exceptions-detailed-label' container justifyContent='center'>
                  <Typography sx={ {
                    display: 'inline',
                    color: 'red',
                    fontWeight: 'bold'
                  } }>Exceptions:

                  </Typography>
                  {/* <Stack> */ }
                  <Typography sx={ {
                    display: 'inline',
                    fontWeight: 'bold',
                    margin: 0,
                    marginLeft: '2px'
                  } }>
                    { totalExceptionCount }
                  </Typography>
                  {/* <GridExpandMoreIcon sx={ {
                    transform: expandableWidgets.has(title) ? 'rotate(-90deg)' : 'rotate(0deg)'
                  } }
                    id='expand-icon'
                  /> */}
                  { renderLegends(exceptions, 'Exceptions') }
                </Grid>
              </Grid>
              {
                states.length > 0 &&
                <Grid id='states-overview' size={ { xs: 4 } }>
                  { renderPieChart('States', statesSeries) }
                  <Grid id='states-label' container justifyContent='center'>
                    <Typography sx={ {
                      display: 'inline',
                      color: 'red',
                      fontWeight: 'bold',
                    } }>
                      States:
                    </Typography>
                    <Typography sx={ {
                      display: 'inline',
                      fontWeight: 'bold',
                      margin: 0,
                      marginLeft: '2px'
                    } }>
                      { totalStatesCount }
                    </Typography>
                    { renderLegends(states, 'States') }
                  </Grid>
                </Grid>
              }
            </>
          }

          {
            expandableWidgets.has(title) &&
            <>
              <Grid id='exceptions-bar' size={ { xs: 6 } }>
                { renderBarChart(exceptions, totalExceptionCount, 'Exceptions', handleItemClick) }
              </Grid>
              <Grid id='states-bar' size={ { xs: 6 } }>
                { renderBarChart(states, totalStatesCount, 'States', handleItemClick) }
              </Grid>
            </>
          }
        </Grid>
      </Grid>
    </>

  const renderPieChart = (type, series) =>
    <PieChart
      aria-label={ `${type}-chart` }
      sx={ {
        justifySelf: 'center'
      } }
      series={ type === 'Exceptions' ? series.slice(0, 3) : series }
      height={ 150 }
      slotProps={ {
        legend: {
          hidden: true
        }
      } }
      className='custom-pie-chart'
      onItemClick={ (event, i, item) => handleItemClick(event, { type, ...item }) }
    />

  const renderLegends = (data, label) => {
    return (
      <Grid id='legends' container spacing={ 1 } padding={ 1 }>
        { data.length > 0 &&
          data.sort((a, b) => a.value - b.value >= 0).slice(0, 3).map(item =>
            <Grid container size='auto' offset={ props.title === 'Inventory' ? 2 : 1 } key={ item.label } maxWidth='100%'>
              <Box
                sx={ {
                  display: 'inline-block',
                  width: 10,
                  height: 10,
                  borderRadius: 0.5,
                  bgcolor: item.color,
                } }
              />
              <Typography display='inline-block' id={ item.label } fontSize={ 10.5 } fontWeight={ 500 }>
                &nbsp;
                { item.label } &nbsp;
              </Typography>
              <Typography display='inline-block' id={ item.label } fontSize={ 10.5 } fontWeight={ 500 }>
                { valueFormatter(item, label === 'Exceptions' ? totalExceptionCount : statesTotal) }
              </Typography>
            </Grid>
          )
        }
      </Grid>
    )
  }

  const viewDetails = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setExpandableWidgets(title);
  }

  const handleItemClick = useCallback((event, item) => {
    event.preventDefault();
    event.stopPropagation();
    setTimeout(() => {
      if (item.type === 'Overview' || item.type === 'Default') {
        navigate(path, {
          state: { menu: menuState, label }
        })
        return;
      }
      navigate(path, {
        state: {
          menu: menuState,
          label,
          [item.type.toLowerCase()]: [{ ...item }]
        }
      })
    }, 500)
  }, [label, menuState, navigate, path])

  return (
    <ThemeProvider theme={ theme }>
      <Grid id='card-container' container size={ { xs: 12 } } sx={ { padding: 0, width: '100%', justifyContent: 'center' } }>
        <Grid id='title' aria-label={ props.title } size={ { xs: 12 } } className="shipmentCard__draggable">
          <Typography fontSize={ 16 } style={ {
            borderRadius: '8px 8px 0 0',
            padding: '5px',
            backgroundColor: 'black',
            color: 'white'
          } }>
            { props.title } &nbsp; { totalShipmentCount && `(${totalShipmentCount})` }
          </Typography>
        </Grid>
        <Stack direction="row" spacing={ 1 } sx={ { alignItems: 'center', alignSelf: 'center', justifyContent: 'normal' } }>
          <Typography>Overview</Typography>
          <CustomSwitch checked={ isDetailed }
            onChange={ (_, checked) => updateActiveTab(checked) }
            slotProps={ {
              thumb: {
                style: {
                  marginLeft: '-20px'
                }
              }
            } }
            theme={ theme }
          />
          <Typography>Detailed</Typography>
        </Stack>
        <ButtonBase disabled={ props.isLoading }
          onClick={ (event) => event.target.id !== 'expand-icon' ?
            handleItemClick(event, { type: 'Default' }) : viewDetails(event) }>
          {
            !props.isLoading && renderCardBody()
          }
        </ButtonBase>
      </Grid >
      { props.isLoading &&
        <Stack size={ { xs: 12 } } alignItems='center' justifyContent='center' height='100%'>
          <CircularProgress aria-label='spinner' color='black' />
        </Stack>
      }
    </ThemeProvider>
  )
}

const renderBarChart = (dataset, total, label, handleItemClick) => {
  const chartSetting = {
    width: 500,
    height: 350,
    margin: { top: 0, left: 150 }
  };
  const valueFormatter = (item) => `${item} \n (${dataset.find(d => d.label === item)?.value || 0})`
  const seriesFormatter = (item) => item > 0 ? `${(item * 100 / total).toFixed(2)}% (${item})` : item
  return (
    <BarChart
      dataset={ dataset }
      xAxis={ [{
        label,
        colorMap: {
          type: 'ordinal',
          values: dataset.map(d => d.value),
          colors: dataset.map(d => d.color)
        }
      }] }
      yAxis={ [{
        scaleType: 'band',
        dataKey: 'label',
        valueFormatter: valueFormatter
      }] }
      series={ [{ dataKey: 'value', valueFormatter: seriesFormatter }] }
      colors={ {} }
      // barLabel={ seriesFormatter }
      onItemClick={ (event, item) => handleItemClick(event, { type: label, ...dataset[item.dataIndex] }) }
      layout="horizontal"
      { ...chartSetting }
    />
  )
}
